import { useEffect, useState } from 'react';
import { TimerData } from '../../types/common';
import { calculateTimeLeft } from '../../utils/timeAndDate';

const AcademiaTimer = ({
  targetDate,
  targetStartTime,
  setIsTimeUp,
}: {
  targetDate: string;
  targetStartTime: string;
  setIsTimeUp: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  // integration of react hooks here
  const [timerData, setTimerData] = useState<TimerData>(
    calculateTimeLeft(targetDate, targetStartTime)
  );

  // running the timer here
  useEffect(() => {
    const timer = setInterval(() => {
      setTimerData(calculateTimeLeft(targetDate, targetStartTime));
    }, 1000);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // checking if session has started or not here
  useEffect(() => {
    if (
      timerData.days === 0 &&
      timerData.hours === 0 &&
      timerData.minutes === 0 &&
      timerData.seconds === 0
    ) {
      setIsTimeUp(true);
    }
  }, [timerData, setIsTimeUp]);

  // rendering custom timer component here
  return (
    <div className='mb-2'>
      <div className='text-sm text-center bg-legal-dark-blue rounded-md px-5 py-1 text-legal-brown'>
        <p>Time Left</p>
        <p className='font-semibold'>
          {timerData.days.toString().padStart(2, '0')} :{' '}
          {timerData.hours.toString().padStart(2, '0')} :{' '}
          {timerData.minutes.toString().padStart(2, '0')} :{' '}
          {timerData.seconds.toString().padStart(2, '0')}
        </p>
      </div>
    </div>
  );
};

export default AcademiaTimer;
